/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForAws extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForAws");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForAws.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForAws>): ServiceAccountCredentialsBaseForAws {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForAws(), model);
        ServiceAccountCredentialsBaseForAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForAws>): ServiceAccountCredentialsBaseForAws {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForAws.newInstance(<ServiceAccountCredentialsBaseForAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForAws) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForAws): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
